import { render, staticRenderFns } from "./FixedBearingsFormDialogDimension.vue?vue&type=template&id=1fa5d1ce&scoped=true"
import script from "./FixedBearingsFormDialogDimension.vue?vue&type=script&lang=js"
export * from "./FixedBearingsFormDialogDimension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa5d1ce",
  null
  
)

export default component.exports